import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {AttributeHistoryPref} from '../constants';

export const attributeHistoryEnabled = () =>
	getPreference(AttributeHistoryPref.ENABLED, true);
